import { useQuery } from "@tanstack/react-query";
import { fetchCatalog } from "@/lib/api";

export function useCatalog() {
  const q = useQuery({ queryKey: ["catalog"], queryFn: fetchCatalog });
  const products = q.data?.products || [];
  const byCategory = (cat) => products.filter((p) => p.categories.includes(cat));
  const bySlug = (slug) => products.find((p) => p.slug === slug);
  return { ...q, products, byCategory, bySlug };
}
